import { EConditionType } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IOfficeConditionsTagType = 'advanced-officeCondition';

export interface IOfficeConditionsTag {
  type: 'advanced-officeCondition';
  value: EConditionType;
}

const isOfficeConditionsTag = (tag: TTag): tag is IOfficeConditionsTag => tag.type === IOfficeConditionsTagType;

export const officeConditionTypesTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.condition_type && jsonQuery.condition_type.value;

    let nextTags = tags.filter(
      tag => tag.type !== IOfficeConditionsTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EConditionType) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IOfficeConditionsTag => isOfficeConditionsTag(tag) && tag.value === value,
            previousTag => ({ type: IOfficeConditionsTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
